/**
 * **くっついて動く帯**（Issue #644。ユーザー判断 2026-10-01）。純関数。
 *
 * **1 つのシチュエーションに 1 組**: 同じ状況名の motion（`<状況>_motion`）と effect（`<状況>`）を 1 組にする。
 * 並びは motion → effect でも effect → motion でもよい。状況が違う帯（例: カードが場に出る `move_enter_motion` と
 * 召喚の強調 `summoning`）は、時刻が続いていても組にしない。
 *
 * 同じ状況の motion と effect は**同じイベント**から作られる（`editorPorts/duelEffects.js::duelSpecs` の型 2 つ）ので、
 * アンカー（イベントの時刻）も同じ。組はそのアンカーの帯で、どちらをドラッグしても組が一緒に動き、
 * ドラッグ中の見た目も組ごと動く。
 */
import { roleOfType } from '../duelEditor/core/effect';

/** アンカーの鍵 → 応答（`{op_uuid}:{msg_offset}` の前半。`start:` は開始時の 1 まとまり） */
export const opOfKey = (key) => String(key ?? '').split(':')[0];

/**
 * その帯と同じ組の帯（自分を含む。時刻の順）＝ 同じイベント・同じ状況名の帯
 * @param clips タイムラインの帯（`source.anchorKey` を持つもの）
 */
export function gluedClips(clips = [], clip) {
  if (!clip?.source?.anchorKey) return clip ? [clip] : [];
  const key = clip.source.anchorKey;
  const { situation } = roleOfType(clip.type);
  return clips
    .filter((o) => o === clip || (o?.source?.anchorKey === key && roleOfType(o.type).situation === situation))
    .sort((a, b) => a.startMs - b.startMs || a.endMs - b.endMs);
}

/** 組のアンカーの鍵（重なりなし） */
export const gluedKeys = (clips, clip) => [...new Set(gluedClips(clips, clip).map((o) => o.source?.anchorKey).filter(Boolean))];
